import { Button } from '@sparemin/blockhead';
import React, { useCallback } from 'react';
import { useClipSelect } from '../ClipSelectContext';
import { useClipPlaybackManager } from '../ClipSelector/ClipPlaybackManagerContext';
import { useClipSelectTracking } from '../ClipSelectTrackingContext';

const HeaderSelectClipButton: React.FC = () => {
  const { onCustom } = useClipSelect();
  const { onSelectOwnClip } = useClipSelectTracking();
  const { stopAll } = useClipPlaybackManager();

  const handleButtonClick = useCallback(() => {
    stopAll();
    onCustom();
    onSelectOwnClip();
  }, [onCustom, onSelectOwnClip, stopAll]);

  return (
    <Button onPress={handleButtonClick} size="small" variant="ghost">
      select a clip
    </Button>
  );
};

export default HeaderSelectClipButton;
